var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticStyle:{"border":"0px","border-radius":"15%","position":"fixed","right":"45px","bottom":"68px","z-index":"1"},attrs:{"variant":"success","href":"https://wa.me/+553140424391?text=Olá preciso de ajuda com meu mapa","target":"_blank"}},[_c('i',{staticClass:"fa fa-whatsapp fa-2x",attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }